import { Type } from "@sinclair/typebox";
import { WsCommand, WsEvent, ErrorCode } from "../enums";
export const WsCommandSchema = Type.Object({
    cmd: Type.Enum(WsCommand),
    payload: Type.Optional(Type.Unknown()),
    version: Type.Optional(Type.Integer()),
});
export const WsJoinPayloadSchema = Type.Object({
    code: Type.String(),
    display_name: Type.String(),
    avatar_seed: Type.String(),
});
export const WsKickPayloadSchema = Type.Object({
    target_user_id: Type.String(),
});
export const WsTransferPayloadSchema = Type.Object({
    target_user_id: Type.String(),
});
export const WsEventSchema = Type.Object({
    event: Type.Enum(WsEvent),
    payload: Type.Unknown(),
    version: Type.Integer(),
});
export const WsErrorPayloadSchema = Type.Object({
    code: Type.Enum(ErrorCode),
    message: Type.String(),
});
